// Drawer sections mirroring the Android app's admin task drawer
// (res/menu/admin_task_drawer.xml). Grouped the same way the original groups them.

export interface NavItem {
  path: string;
  label: string;
  icon: string;
  group: string;
}

export const NAV_ITEMS: NavItem[] = [
  // Home
  { path: '/dashboard', label: 'Dashboard', icon: '🏠', group: 'Home' },

  // Billing
  { path: '/', label: 'Bill', icon: '🧾', group: 'Billing' },
  { path: '/edit-bill', label: 'Edit Bill', icon: '✏️', group: 'Billing' },
  { path: '/sale-return', label: 'Sale Return', icon: '↩️', group: 'Billing' },

  // Inventory
  { path: '/products', label: 'Product Master', icon: '📦', group: 'Inventory' },
  { path: '/categories', label: 'Category Master', icon: '🗂️', group: 'Inventory' },
  { path: '/units', label: 'Unit Master', icon: '📐', group: 'Inventory' },
  { path: '/attributes', label: 'Attribute Master', icon: '🏷️', group: 'Inventory' },
  { path: '/suppliers', label: 'Supplier Master', icon: '🚚', group: 'Inventory' },
  { path: '/salesmen', label: 'Salesman Master', icon: '🧑‍💼', group: 'Inventory' },
  { path: '/service-points', label: 'Service Points', icon: '🍳', group: 'Inventory' },
  { path: '/goods-received', label: 'Goods Received', icon: '📥', group: 'Inventory' },
  { path: '/stock-out', label: 'Stock Out', icon: '📤', group: 'Inventory' },
  { path: '/order-request', label: 'Order Request (GR)', icon: '📋', group: 'Inventory' },

  // Money
  { path: '/cashflow', label: 'CashFlow', icon: '💰', group: 'Money' },
  { path: '/customers', label: 'Customers', icon: '👥', group: 'Money' },
  { path: '/customer-report', label: 'Customer Report', icon: '📒', group: 'Money' },
  { path: '/coupons', label: 'Coupons', icon: '🎟️', group: 'Money' },
  { path: '/discounts', label: 'Discounts', icon: '💸', group: 'Money' },

  // Restaurant
  { path: '/tables', label: 'Tables', icon: '🍽️', group: 'Restaurant' },
  { path: '/recipes', label: 'Recipe Master', icon: '🧪', group: 'Restaurant' },
  { path: '/captain', label: 'Captain App', icon: '🧑‍🍳', group: 'Restaurant' },
  { path: '/kitchen', label: 'Kitchen Display', icon: '👨‍🍳', group: 'Restaurant' },
  { path: '/kot-report', label: 'KOT Report', icon: '🧾', group: 'Restaurant' },

  // Rooms (hotel)
  { path: '/rooms', label: 'Rooms', icon: '🛏️', group: 'Rooms' },

  // Online
  { path: '/online-orders', label: 'Online Orders', icon: '🛵', group: 'Online' },
  { path: '/swiggy-zomato', label: 'Swiggy & Zomato', icon: '🍔', group: 'Online' },

  // Reports
  { path: '/reports', label: 'Reports', icon: '📊', group: 'Reports' },
  { path: '/head-office', label: 'Head Office', icon: '🏢', group: 'Reports' },
  { path: '/d-reports', label: 'D - Reports', icon: '📅', group: 'Reports' },
  { path: '/e-reports', label: 'E - Reports', icon: '📈', group: 'Reports' },
  { path: '/ngst-summary', label: 'NGST Summary', icon: '🧮', group: 'Reports' },
  { path: '/gst-reports', label: 'GST Reports', icon: '🧾', group: 'Reports' },
  { path: '/product-sale-report', label: 'Product Sale Report', icon: '📦', group: 'Reports' },
  { path: '/transport-report', label: 'Transport Report', icon: '🚛', group: 'Reports' },
  { path: '/excel-email', label: 'Excel Export & Import', icon: '📊', group: 'Reports' },

  // Shifts
  { path: '/opening-balance', label: 'Opening Balance', icon: '🌅', group: 'Shifts' },
  { path: '/shift-end', label: 'Shift End', icon: '🔚', group: 'Shifts' },
  { path: '/shifts', label: 'Shifts', icon: '🕐', group: 'Shifts' },

  // Config
  { path: '/barcode-printing', label: 'Barcode Printing', icon: '🏷️', group: 'Config' },
  { path: '/barcode-settings', label: 'Barcode Settings', icon: '⚙️', group: 'Config' },
  { path: '/print-settings', label: 'Print Settings', icon: '🖨️', group: 'Config' },
  { path: '/app-settings', label: 'App Setting', icon: '🎛️', group: 'Config' },
  { path: '/usb-link', label: 'USB Devices', icon: '🔌', group: 'Config' },
  { path: '/users', label: 'Users', icon: '👤', group: 'Config' },
  { path: '/audit-log', label: 'Audit Log', icon: '🗒️', group: 'Config' },
  { path: '/licenses', label: 'Licences', icon: '🔑', group: 'Config' },
  { path: '/settings', label: 'Settings', icon: '⚙️', group: 'Config' },
  { path: '/about', label: 'About', icon: 'ℹ️', group: 'Config' },

  // Devices & Integrations (hardware/backend — stubbed in the web port)
  { path: '/bluetooth-printer', label: 'Bluetooth Printer', icon: '🖨️', group: 'Devices' },
  { path: '/rfid', label: 'RFID Reader', icon: '📡', group: 'Devices' },
  { path: '/led-display', label: 'Customer Display', icon: '🔢', group: 'Devices' },
  { path: '/qr-login', label: 'QR Login', icon: '🔳', group: 'Devices' },
  { path: '/sms-config', label: 'SMS Configuration', icon: '✉️', group: 'Devices' },
  { path: '/app-update', label: 'App Update', icon: '⬆️', group: 'Devices' },
];

// Order in which groups appear in the drawer.
export const NAV_GROUPS = ['Home', 'Billing', 'Inventory', 'Money', 'Restaurant', 'Rooms', 'Online', 'Reports', 'Shifts', 'Config', 'Devices'];

// Drawer items gated by Menu Option toggles (app_setting_layout.xml "3 - Menu
// Option" + "5 - Sales Return"). Path → setting key; paths absent here always show.
export const MENU_GATES: Record<string, string> = {
  '/cashflow': 'enable_payment_menu',
  '/goods-received': 'enable_goods_received_menu',
  '/stock-out': 'enable_stock_out_menu',
  '/barcode-printing': 'barcode_menu',
  '/sale-return': 'sales_return',
  // "8 — Swiggy & Zomato Setting / A. Swiggy And Zomato" gates the Online group.
  '/online-orders': 'online_order_system',
  '/swiggy-zomato': 'online_order_system',
  // "10 — Day Setting / B - Enable Shift" gates the Shifts group.
  '/shifts': 'enable_shift',
  '/shift-end': 'enable_shift',
  '/opening-balance': 'enable_shift',
  // "15 — Table Settings / E - CheckIn/CheckOut" gates the hotel Rooms module.
  '/rooms': 'checkin_checkout',
  // "17 — Captain App Setting / A. Captain App".
  '/captain': 'captain_app',
};
